import {
    Driver,
    KbmReponse,
    IRequestOptions,
    IRequestConfig,
    getConfigs,
    axios,
    basePath,
    ApiResponse,
    DkRequest,
    DkResponse,
    AutocodeResponse,
    AutocodeInfoResponse,
} from "./index.defs";

export class InfoService {
    /**
     *
     */
    static getKbm(
        params: {
            /** requestBody */
            body?: Driver;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ApiResponse<KbmReponse>> {
        return new Promise((resolve, reject) => {
            const url = basePath + "/info/getKbm";

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            const data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getDk(
        params: {
            /** requestBody */
            body?: DkRequest;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ApiResponse<DkResponse>> {
        return new Promise((resolve, reject) => {
            const url = basePath + "/info/getDk";

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);

            const data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static getAuto(
        params: {
            /**  */
            licensePlate?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ApiResponse<AutocodeResponse>> {
        return new Promise((resolve, reject) => {
            const url = basePath + "/info/getAuto";

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);
            configs.params = { licensePlate: params["licensePlate"] };
            const data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    static getAutoCodeInfo(
        params: {
            licensePlate?: string;
            token?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ApiResponse<AutocodeInfoResponse>> {
        return new Promise((resolve, reject) => {
            const url = basePath + "/info/getAutoCodeInfo";

            const configs: IRequestConfig = getConfigs("post", "application/json", url, options);
            configs.params = { licensePlate: params["licensePlate"], token: params["token"] };
            configs.data = null;
            axios(configs, resolve, reject);
        });
    }
}
